
import { Options, Vue } from 'vue-class-component';
import { ProviderPortalClient } from '@/services/DueDiligenceServices';
import InfoModal from '@/components/modals/infoModal.vue';
import * as DDM from '@/dueDiligenceModels';

@Options({})
export default class ProviderProfile extends Vue {

    model: DDM.SaveProviderProfileVM = new DDM.SaveProviderProfileVM();
    loaded: boolean = false;
    isReadOnly: boolean = false;
    providerEmail: string = "";
    submittedFactoryIds: string[] = [];

    valueChainOptions: string[] = [
        "Raw Material Supplier",
        "Manufacturer",
        "Service Provider"
    ];

    codeAssigned = false;

    created() {
        this.init();
    }

    init() {
        ProviderPortalClient.getProfile()
        .then(x => {
            this.isReadOnly = x.status === DDM.ProviderProfileStatus.SurveyCompleted;
            this.providerEmail = x.providerEmail || "";
            this.codeAssigned = !!x.registry?.code?.trim();
            this.model.registry = x.registry || new DDM.ProviderRegistryInfo();
            this.model.registry.email = this.providerEmail;
            this.model.registry.companyName = this.model.registry.companyName || x.companyLegalName || "";
            this.model.companyLegalName = x.companyLegalName || "";
            this.model.registeredAddress = x.registeredAddress || "";
            this.model.operationalSites = x.operationalSites || [];
            this.model.operationalCountries = x.operationalCountries || [];
            this.model.legalForm = x.legalForm || "";
            this.model.establishmentYear = x.establishmentYear;
            this.model.parentCompanyGroupStructure = x.parentCompanyGroupStructure || "";
            this.model.numberOfEmployees = x.numberOfEmployees || [];
            this.model.annualTurnover = x.annualTurnover || [];
            this.model.mainActivities = x.mainActivities || "";
            this.model.valueChainPosition = x.valueChainPosition || "";
            this.model.esgContactPerson = x.esgContactPerson || new DDM.EsgContactPerson();
            this.model.factories = x.factories || [];
            this.model.declarationAccepted = x.declarationAccepted;
            this.model.declarationName = x.declarationName || "";
            this.model.declarationPosition = x.declarationPosition || "";
            this.model.declarationDate = x.declarationDate;

            // Load factory survey status to know which can't be removed
            ProviderPortalClient.getSurvey(undefined, false)
            .then(s => {
                this.submittedFactoryIds = (s.factorySummaries || [])
                    .filter(fs => fs.responseStatus === DDM.SurveyResponseStatus.Submitted)
                    .map(fs => fs.factoryId);
                this.loaded = true;
            })
            .catch(() => {
                this.loaded = true;
            });
        });
    }

    get saveDisabled(): boolean {
        let r = this.model.registry;
        return !this.providerEmail.trim()
            || !(r.code || "").trim()
            || !(r.companyName || "").trim()
            || !(r.status || "").trim()
            || !(r.vatNumber || "").trim()
            || !(r.address || "").trim()
            || !(r.locality || "").trim()
            || !(r.province || "").trim()
            || !(r.country || "").trim()
            || !(r.language || "").trim()
            || !(r.typology || "").trim()
            || this.model.factories.length === 0
            || this.model.factories.some(f => !f.name.trim() || !f.address.trim());
    }

    addFactory() {
        let f = new DDM.Factory();
        f.factoryId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        this.model.factories.push(f);
    }

    removeFactory(index: number) {
        this.model.factories.splice(index, 1);
    }

    factoryHasSubmittedSurvey(factory: DDM.Factory): boolean {
        return this.submittedFactoryIds.includes(factory.factoryId);
    }

    save() {
        this.model.companyLegalName = this.model.registry.companyName;
        ProviderPortalClient.saveProfile(this.model)
        .then(x => {
            this.model.companyLegalName = x.companyLegalName || this.model.registry.companyName;
            this.model.registeredAddress = x.registeredAddress || "";
            this.model.registry = x.registry || this.model.registry;
            this.codeAssigned = !!this.model.registry.code?.trim();
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Success", "Success"),
                subtitle: this.$localizationService.getLocalizedValue("Profile saved successfully", "Profile saved successfully"),
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => { this.$opModal.closeLast(); }
            });
        })
        .catch(err => {
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: err.Message || err,
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => { this.$opModal.closeLast(); }
            });
        });
    }
}
